/**
 * Polyfills for browser compatibliity.
 */

import 'core-js/fn/object/assign'; // For IE11.
import 'core-js/fn/array/includes'; // For IE11.
